import { Shield, Target, Lightbulb, Network } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const AboutSection = () => {
  const { t, isRTL } = useLanguage();

  const values = [
    {
      icon: Shield,
      titleKey: "about.value.trust.title",
      descKey: "about.value.trust.desc",
    },
    {
      icon: Target,
      titleKey: "about.value.results.title",
      descKey: "about.value.results.desc",
    },
    {
      icon: Lightbulb,
      titleKey: "about.value.knowledge.title",
      descKey: "about.value.knowledge.desc",
    },
    {
      icon: Network,
      titleKey: "about.value.ecosystem.title",
      descKey: "about.value.ecosystem.desc",
    },
  ];

  return (
    <section id="about" className="synra-section relative">
      <div className="synra-container">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Content */}
          <div className="text-start">
            <span className="text-primary font-medium text-sm uppercase tracking-wider mb-4 block">
              {t("about.label")}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
              {t("about.title")}{' '}
              <span className="synra-gradient-text">{t("about.titleHighlight")}</span>
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed mb-6">
              {t("about.description1")}
            </p>
            <p className="text-muted-foreground leading-relaxed">
              {t("about.description2")}
            </p>
          </div>

          {/* Values Grid */}
          <div className="synra-equal-grid sm:grid-cols-2">
            {values.map((value, index) => (
              <div
                key={value.titleKey}
                className="synra-card group text-start"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors duration-300">
                  <value.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-heading font-semibold text-foreground text-lg mb-2">
                  {t(value.titleKey)}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {t(value.descKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;